import {
  BasketBadge,
  BasketButton,
  HeaderInner,
  HeaderWrapper,
  Logo,
  LogoLink,
  PropertyName,
} from './Layout.styles';
import type { HeaderProps } from './Layout.types';

export { PageContainer } from './Layout.styles';

export function Header({
  propertyName,
  logoUrl,
  basketCount = 0,
  onBasketClick,
  onLogoClick,
  bgColor,
  basketLabel = 'Basket',
}: HeaderProps) {
  return (
    <HeaderWrapper $bgColor={bgColor}>
      <HeaderInner>
        <LogoLink onClick={onLogoClick} type="button" aria-label={propertyName}>
          {logoUrl ? (
            <Logo src={logoUrl} alt={propertyName} loading="eager" />
          ) : (
            <PropertyName>{propertyName}</PropertyName>
          )}
        </LogoLink>
        <BasketButton onClick={onBasketClick} type="button">
          {basketLabel}
          {basketCount > 0 && <BasketBadge>{basketCount}</BasketBadge>}
        </BasketButton>
      </HeaderInner>
    </HeaderWrapper>
  );
}
